import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { patch } = request;
const { Authorization, Bearer } = AUTHORIZATION;

const initialRoute = "auth";

export type MemberChangePasswordTypes = {
	group_number: number;
	SSN: string;
	new_password: string;
};

export const memberChangePassword = async (_payload: MemberChangePasswordTypes) => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/member-change-password`;
		const token = localStorage.getItem("@jwt");
		const response = await patch(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === "Member Password has been changed successfully!") {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
